import { p as proxyCustomElement, H, h, c as Host } from './p-d3SrgL0G.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.7.0
 */

const PageHeaderNav = /*@__PURE__*/ proxyCustomElement(class PageHeaderNav extends H {
    constructor() {
        super();
        this.__registerHost();
    }
    componentDidLoad() {
        requestAnimationFrame(() => this.scrollToSelected());
    }
    scrollToSelected() {
        const ulElement = this.el.querySelector("ul");
        if (!ulElement)
            return;
        const selectedItem = ulElement.querySelector(".selected");
        if (selectedItem) {
            const bounds = selectedItem.getBoundingClientRect();
            const ulBounds = ulElement.getBoundingClientRect();
            if (bounds.right > ulBounds.right || bounds.left < ulBounds.left) {
                ulElement.scrollTo({
                    left: ulElement.scrollLeft + bounds.left - ulBounds.left,
                });
            }
        }
    }
    render() {
        return (h(Host, { key: 'fb36d577f2d4046951bc02e81acd8efaac4d76a9', slot: "navigation" }, h("slot", { key: 'd2b9cf009bf6d1de1565efe5b0f46692cd996bad', name: "navigation" }), h("slot", { key: 'a4f2a5021ef8e74828b1e3578e63c9dff8a4ab03' })));
    }
    get el() { return this; }
}, [4, "tds-page-header-nav"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-page-header-nav"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-page-header-nav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PageHeaderNav);
            }
            break;
    } });
}

export { PageHeaderNav as P, defineCustomElement as d };
//# sourceMappingURL=p-4FlsIiUz.js.map
